/**
 * Module for Custom Surgeon Cell.
 * @module src/Events/EventsList
 */
import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';

interface Surgeon {
  surgeonFirstName: string;
  surgeonLastName: string;
  alignedSurgeonId?: string;
  alignedSurgeonName?: string;
}
interface Props {
  item?: Surgeon;
}

const EventsListSurgeonCell: FC<Props> = ({
  item = {
    surgeonFirstName: '',
    surgeonLastName: '',
    alignedSurgeonId: '',
    alignedSurgeonName: '',
  },
}) => {
  const { surgeonFirstName, surgeonLastName, alignedSurgeonName } = item;
  const surgeonDisplay = alignedSurgeonName || `${surgeonFirstName || ''} ${surgeonLastName || ''}`.trim();

  return (
    <DataTableCell title={surgeonDisplay}>
      <div>
        {surgeonDisplay && (
          <p className="wrap-text">{surgeonDisplay}</p>
        )}
      </div>
    </DataTableCell>
  );
};

/** Custom Surgeon Cell */
export default EventsListSurgeonCell;
